import Skeleton from '@carvana/ds-skeleton';
import LiveAnnouncer from '@/common/LiveAnnouncer';
import LoadingRecentSearchTile from './LoadingRecentSearchTile';

export default function LoadingSavedSearchCarousel() {
  return (
    <div
      className="lg:px-4xl xl:max-w-[1352px]"
      data-testid="loading-saved-search-carousel"
    >
      <LiveAnnouncer message="Loading recent searches" />
      {/* header */}
      <div className="px-2xl sm:px-4xl md:px-3xl lg:px-0">
        <Skeleton height="28px" width="200px" />
      </div>

      <div className="mt-3xl flex gap-2xl overflow-hidden px-2xl sm:px-4xl md:px-3xl lg:px-0">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="w-[300px] shrink-0 sm:w-[280px] lg:w-[300px]"
          >
            <LoadingRecentSearchTile />
          </div>
        ))}
      </div>

      {/* pagination dots */}
      <div className="mt-3xl flex justify-center">
        <Skeleton height="7px" width="80px" className="rounded-full" />
      </div>
    </div>
  );
}
